import { render, staticRenderFns } from "./AllProperties.vue?vue&type=template&id=dce3160e"
import script from "./AllProperties.vue?vue&type=script&lang=js"
export * from "./AllProperties.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports